require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/es7.symbol.observable.js
// module id = 635
// module chunks = 23 41